import React, { useState, useEffect } from 'react'
import { Form, Input, Select, Button, Row, Col, message } from 'antd'
import { ColProps } from 'antd/es/col'
import AudioPlay from '../AudioPlay'
import * as API from '../../../api'

export interface TextToRadioLayout {
	labelCol?: ColProps;
	textWrapperCol?: ColProps;
	readerWrapperCol?: ColProps;
}

export interface TextAudioType {
	st_text: string;   // 文字
	st_reader: string; // 朗读方式
	st_fileurl: string; // 文件地址
}

export interface TextToAudioProps {
	layout?: TextToRadioLayout;
	value?: TextAudioType;
	onChange?: (val: TextAudioType) => void;
}

const TextToAudio: React.FC<TextToAudioProps> = ({
	layout,
	value,
	onChange,
}) => {
	const [audioSrc, setAudioSrc] = useState<string>(value?.st_fileurl || '')
	const [text, setText] = useState<string>(value?.st_text || '')
	const [reader, setReader] = useState<string>(value?.st_reader || '女声')
	const [textOnBlur, setTextOnBlur] = useState<string>(value?.st_fileurl || '')

	useEffect(() => {
		onChange && onChange({
			st_text: text,
			st_reader: reader,
			st_fileurl: audioSrc,
		})
	}, [audioSrc])

	useEffect(() => {
		if (!value) return
		const { st_fileurl, st_reader, st_text } = value
		setAudioSrc(st_fileurl)
		setText(st_text)
		setReader(st_reader)
		setTextOnBlur(st_fileurl)
	}, [value])

	/**
	 * 获取音频
	 */
	const getAudio = () => {
		return new Promise((resolve, reject) => {
			if (!text) {
				message.warning('请输入文字')
				reject()
				return
			}

			API.textToAudio({ tarText: text }).then(res => {
				const { code, data, msg } = res
				if (code === 0 && data) {
					setAudioSrc(data)
					resolve(data)
				} else {
					const errMsg = msg || '获取音频失败！'
					message.error(errMsg)
					reject(errMsg)
				}
			}).catch(err => {
				message.error('文字转音频失败！请稍后重试')
				reject(err)
			})
		})
	}

	const onAudioPlayError = () => {
		// 播放失败 清空音频
		setAudioSrc('')
		console.error('文字转音频播放失败')
	}

	const onTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setText(e.target.value)
	}

	const onTextBlur = () => {
		if (text !== textOnBlur) {
			setTextOnBlur(text)
			if (audioSrc) { // 输入框失焦 如果值发生变化 清空音频链接 待后续点击【试听】重新获取
				setAudioSrc('')
				message.warning('文字发生变化，请点击试听重新获取音频')
			}
		}
	}

	const onReaderSelectChange = (val: string) => {
		setReader(val)
	}

	return (
		<>
			<Form.Item label="文字转音频" labelCol={layout?.labelCol} wrapperCol={layout?.textWrapperCol}>
				<Input.TextArea
					rows={7}
					value={text}
					onChange={onTextChange}
					onBlur={onTextBlur}
				/>
			</Form.Item>
			<Form.Item label="朗读方式" style={{ marginBottom: 0 }} labelCol={layout?.labelCol} wrapperCol={layout?.readerWrapperCol}>
				<Row gutter={10}>
					<Col span={6} style={{marginRight: '10px'}}>
						<Select value={reader} style={{width: '103%'}} onChange={onReaderSelectChange}>
							<Select.Option value="女生">女声</Select.Option>
						</Select>
					</Col>
					<AudioPlay src={audioSrc} getAudio={getAudio} onError={onAudioPlayError} />
				</Row>
			</Form.Item>
		</>
	)
}

TextToAudio.defaultProps = {
	layout: {
		labelCol: { span: 8 },
		textWrapperCol: { span: 8 },
		readerWrapperCol: { span: 16 },
	},
}

export default TextToAudio